export default [
    {
        path: '/spIndex', // 特殊旅客首页
        component: resolve => require(['@/pages/special/spIndex'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/spNeedKnow', // 特殊旅客办理须知
        component: resolve => require(['@/pages/special/spNeedKnow'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/spTravellerLogin', // 特殊旅客登录
        component: resolve => require(['@/pages/special/spTravellerLogin'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/spSelectFlight', // 特殊旅客选择航班
        component: resolve => require(['@/pages/special/spSelectFlight'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/spAddInfo', // 特殊旅客补充信息
        component: resolve => require(['@/pages/special/spAddInfo'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/spApply', // 特殊旅客申请
        component: resolve => require(['@/pages/special/spApply'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/spSearch', // 特殊旅客查询
        component: resolve => require(['@/pages/special/spSearch'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/spApplyList', // 特殊旅客审核记录
        component: resolve => require(['@/pages/special/spApplyList'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/spApplyResult', // 特殊旅客审核结果
        component: resolve => require(['@/pages/special/spApplyResult'], resolve),
        meta: { title: "长龙航空" }
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/special.js